import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";

import { HELP_DISTINCTIVE_RINGTONE } from "@/constants/HelpUrls";
import MasterDetail from "@/design/layouts/MasterDetail";
import { setHelpUrl } from "@/store/reducers/ui";

import { useHotkey } from "@tanstack/react-hotkeys";

import DistinctiveRingtone from "./DistinctiveRingtone";
import DistinctiveRingtoneList from "./DistinctiveRingtoneList";

export default function DistinctiveRingtones() {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setHelpUrl(HELP_DISTINCTIVE_RINGTONE));
  }, [dispatch]);

  useHotkey("Alt+N", () => navigate(`/pbx/${params.pbxId}/settings/distinctive-ringtones/new`));

  return <MasterDetail identifier="id" master={<DistinctiveRingtoneList />} detail={<DistinctiveRingtone />} />;
}
